import { useContext, useEffect, useState } from 'react';
import { getCustomisationFieldData, getCustomisationValue, updateCustomisationValue } from '../../../EditablePreview/EditablePreview';
import ModuleNumericalInput from '../../components/ModuleNumericalInput';
// import './CustomModule.scss';
import { changeNumericalFieldValue, changeStringFieldValue, changeValue_noType } from '../../ModuleList';
import ModuleTextInput from '../../components/ModuleTextInput';
import { ShowColorPicker } from '../../../../../../forms/ColorPicker/ColorPickerPopUp';
import { CampaignContext } from "../../../../../../../contexts/CampaignContext";

import ImageIcon from '../../../../WorkspaceAssets/ListIcons/image-icon.png';
import { COLOUR_NAME_TO_COLOUR_HEX } from '../../../../../../../helpers/Colours';
import Toggle from './toggleSwitch/Toggle';
import { WORKING_ON_NODE_DATA } from '../../../EditablePreview/VisualisedComponents/VisualisedNode';

const ToggleField = (props) => {
    const fieldData = props.fieldData;
    const moduleConfig = props.moduleConfig;
    const groupConfig = props.groupConfig;
    const customisationVars = props.customisationVars;

    // const [campaignContext, setCampaignContext] = useContext(CampaignContext);

    let optionsData = [
        { label: 'Yes', value: true },
        { label: 'No', value: false }
    ];
    /* if (fieldData?.customFieldConfig?.dataLink) {
        optionsData = getCustomisationFieldData(campaignContext.campaignData, props.selectedFeatureNode.path, fieldData.customFieldConfig.dataLink);
    } */
    const findDisplayValue = (value) => {
        // console.log("Boolean dropdown: Finding display value for:", value, optionsData, typeof value);
        const option = optionsData?.find(opt => (opt.value === value || opt.val === value));
        // console.log("Boolean dropdown: Found option:", option);
        return option ? option.label : value;
    }

    const getBoolValue = (value) => {
        if (fieldData?.customFieldConfig?.onValue !== undefined && fieldData?.customFieldConfig?.onValue !== null && value === fieldData?.customFieldConfig?.onValue) {
            return true;
        } else
        if (fieldData?.customFieldConfig?.offValue !== undefined && fieldData?.customFieldConfig?.offValue !== null && value === fieldData?.customFieldConfig?.offValue) {
            return false;
        } else
        if (value === true || value === 'true' || value === 'True') {
            return true;
        } else {
            return false;
        }
    }

    const [currentValue, setCurrentValue] = useState(getBoolValue(getCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? null));
    useEffect(() => {
        setCurrentValue(getBoolValue(getCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? null));
    }, [customisationVars, fieldData, props.index, props.visualisationComponentKey, props.selectedFeatureNode, getCustomisationValue(customisationVars, fieldData?.customFieldConfig?.dataLink, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)]);

    const changeFieldValue = (fieldId, value) => {
        let valBool = value === 'true' || value === true || value === 'True';
        let valueToSet = valBool;
        if (valBool && fieldData?.customFieldConfig?.onValue !== undefined && fieldData?.customFieldConfig?.onValue !== null) {
            valueToSet = fieldData?.customFieldConfig?.onValue;
        }
        if (!valBool && fieldData?.customFieldConfig?.offValue !== undefined && fieldData?.customFieldConfig?.offValue !== null) {
            valueToSet = fieldData?.customFieldConfig?.offValue;
        }
        if (changeValue_noType(customisationVars, fieldData?.customFieldConfig, valueToSet, props.index ?? 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode)) {
            WORKING_ON_NODE_DATA.fieldData = fieldData;
            WORKING_ON_NODE_DATA.node = props.selectedFeatureNode;
            setCurrentValue(valBool);
            props?.forceUpdateComponent?.();
        }
    }

    return (
        <>
            <div className={`v2-module-field-label${!props.isEnabled ? ' disabled' : ''}`}>{fieldData?.customFieldConfig?.customFieldLabel ?? 'Choose'}</div>
            {/* <ModuleTextInput
                value={findDisplayValue(currentValue)}
                fieldId={'toggle-drop-down'}
                enabled={true}
                editable={false}
                onChange={changeFieldValue}
                hiddenDropDown={true}
                hiddenDropDownOptions={optionsData || []}
                dropDownValue={currentValue}
            /> */}
            <div className={`v2-field-holder${!props.isEnabled ? ' v2-module-disabled-field' : ''}`}>
                <Toggle
                    value={currentValue}
                    onToggle={props.isEnabled ? () => changeFieldValue(fieldData?.customFieldConfig?.fieldId, !currentValue) : null}
                />
            </div>
        </>
    );
};

export default ToggleField;
